import { render, staticRenderFns } from "./noAuth.vue?vue&type=template&id=56071937&scoped=true&"
import script from "./noAuth.vue?vue&type=script&lang=js&"
export * from "./noAuth.vue?vue&type=script&lang=js&"
import style0 from "./noAuth.vue?vue&type=style&index=0&id=56071937&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56071937",
  null
  
)

export default component.exports